export const convertDurationToMinutes = (
    duration: number | undefined
): string | undefined => {
    if (duration) {
        return `${Math.floor(duration / 1000 / 60)} min`
    }
}
